export const breakpoints = {
  mobile: 400,
  tablet: 640,
  laptop: 870,
  desktop: 1024,
};

/* import this function into component */
const mediaQuery = Object.keys(breakpoints).reduce((acc, item) => {
  acc[item] = `@media screen and (min-width: ${breakpoints[item]}px)`;
  return acc;
}, {});

export default mediaQuery;
